import React, { useState, useEffect, useContext } from "react";
import {
  DataGrid,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarDensitySelector,
  GridToolbar,
} from "@mui/x-data-grid";
import "./BillingPayment.scss";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { CheckToken } from "../login/AccessToken";
import axios from "axios";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import VisibilityIcon from "@mui/icons-material/Visibility";
import ReceiptIcon from "@mui/icons-material/Receipt";
import MailIcon from "@mui/icons-material/Mail";
import Drawer from "@mui/material/Drawer";
import Fab from "@mui/material/Fab";
import Tooltip from "@mui/material/Tooltip";
import Button from "@mui/material/Button";
import StagingArea from "./StagingArea";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import InvoicePayment from "./InvoicePayment";

import { Box, Card, Grid, Typography } from "@mui/material";
import Navlogo from "../../assets/images/logo/NavLogo.png";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import showConfirmDialog from "../../components/ShowConfirmDialog/ShowConfirmDialog";
import SideNavbar from "./SideNavbar";
import NoDataPage from "./NoDataPage";
import { BrandingContext } from "../../BrandingProvider";
import { usePermissions } from "../login/PermissionContext";
import { toast } from "react-toastify";
// import FooterPdfTemplateWithDept from "../Branding/FooterPdfTemplateWithDept";
import SaveAlt from "@mui/icons-material/SaveAlt";
import { CSVLink } from "react-csv";
import { displayPatientName } from "../../utils/displayPatientName";
import "jspdf-autotable";
// Rename the component to Invoice
const Invoice = () => {
  const { userInfo } = usePermissions();
  const roleType = userInfo?.role_permission?.[0]?.role ?? "";
  const isBillingAdmin =
    roleType === "billingAdmin";

  const brandingData = useContext(BrandingContext);
  const history = useHistory();
  const REACT_APP_BACKEND_ROUTE_URL = process.env.REACT_APP_BACKEND_ROUTE_URL;
  const [facilityName, setFacilityName] = useState(
    sessionStorage.getItem("facility_name") || ""
  );
  const REACT_APP_SENDER_EMAIL = process.env.REACT_APP_SENDER_EMAIL;
  const [drawerOpen, setDrawerOpen] = useState(false);
  // const [departments, setDepartments] = useState([]);
  const isEmailEnabled = sessionStorage.getItem("isEmailEnabled") !== "false";
  useEffect(() => {
    if (
      sessionStorage.getItem("accessToken") == undefined &&
      sessionStorage.getItem("accessToken") == null
    ) {
      history.push("/login");
    }
  }, []);
  // Update the route for adding a new invoice
  const handleAddItem = () => {
    history.push("/newInvoice");
  };

  const [authToken, setAuthToken] = useState("");
  const [invoiceList, setInvoiceList] = useState([]);
  const [invoiceLoading, setInvoiceLoading] = useState(false);
  const [invoicePagination, setInvoicePagination] = useState({
    page: 1,
    limit: 10,
    total_records: 0,
    total_pages: 0,
    has_next: false,
    has_prev: false,
    next_page: null,
    prev_page: null,
  });
  // DataGrid uses 0-based page index; backend uses 1-based.
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 10,
  });

  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const [pdfDataUri, setPdfDataUri] = useState(null);

  const [openPaymentModal, setOpenPaymentModal] = useState(false);
  const [invoiceForPayment, setInvoiceForPayment] = useState(null);

  const handlePayNow = (row) => {
    setInvoiceForPayment(row);
    setOpenPaymentModal(true);
  };

  const getInvoicePaidAmount = (row) => {
    let paid = parseFloat(row?.partial_payment ?? row?.amount_paid ?? 0);
    if (Array.isArray(row?.payment_details) && row.payment_details.length > 0) {
      const sumFromDetails = row.payment_details.reduce(
        (sum, p) => sum + Number(p?.payment_amount ?? 0),
        0,
      );
      if (sumFromDetails > paid) paid = sumFromDetails;
    }
    return paid;
  };

  const getInvoiceOutstanding = (row) => {
    const total = parseFloat(row?.total_amount || 0);
    const paid = getInvoicePaidAmount(row);
    const diff = total - paid;
    return diff > 0.001 ? diff : 0;
  };

  const formatInr = (n) =>
    Number(n || 0).toLocaleString("en-IN", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

  // const handleSendMail = (id) => {
  //   const foundEstimate = invoiceList.find((invoice) => invoice.invoice_id === id);

  //   if (foundEstimate) {
  //     setSelectedInvoice(foundEstimate);

  //   } else {
  //     console.error(`Invoice with id ${id} not found in invoice list`);
  //   }
  // };
  const handleSendMail = async (id) => {
    const message = `Are you sure you want to send this invoice via mail?`;
    const isConfirmed = await showConfirmDialog(message);

    if (isConfirmed) {
      const foundInvoice = invoiceList.find(
        (invoice) => invoice.invoice_id === id
      );

      if (foundInvoice) {
        setSelectedInvoice(foundInvoice);
      } else {
        console.error(`Invoice with id ${id} not found in invoice list`);
      }
    } else {
      console.log("Sending email canceled");
    }
  };
  // const fetchDepartments = async () => {
  //   try {
  //     const headers = { Authorization: `Bearer ${authToken}` };
  //     const response = await axios.get(
  //       `${REACT_APP_BACKEND_ROUTE_URL}get_all_medical_departments/`,
  //       { headers }
  //     );
  //     setDepartments(response.data.department_list);
  //   } catch (error) {
  //     console.error("Error fetching departments", error);
  //   }
  // };

  // useEffect(() => {
  //   fetchDepartments();
  // }, [authToken]);
  useEffect(() => {
    if (selectedInvoice) {
      generateAndDownloadPDF();
    }
  }, [selectedInvoice]);
  useEffect(() => {
    if (pdfDataUri) {
      sendEmail();
    }
  }, [pdfDataUri]);

  const sendEmail = () => {
    try {
      console.log("Preparing to send email...");
      let bannerBase64 = null;

      const bannerObject = brandingData.find(
        (item) => item.name === "email_banner" && item.type === "image"
      );

      if (bannerObject) {
        bannerBase64 = bannerObject.content; // Get the base64 content
      } else {
        console.error("Banner image not found in branding data");
        toast.error("Failed to find the banner image.");
        return;
      }
      const base64Data = pdfDataUri.split(",")[1];

      const emailData = {
        SENDER: REACT_APP_SENDER_EMAIL,
        SUBJECT: "New Invoice Created Successfully",
        RECIPIENT: selectedInvoice.patient_email,
        ATTACHMENT: [
          {
            FILE: base64Data,
            FILENAME: "attach.pdf",
          },
        ],
        TYPE: "INVOICE",
        BANNER: bannerBase64,
      };
      // if (
      //   sessionStorage.getItem("isEmailEnabled") === "true" &&
      //   selectedInvoice.patient_email
      // ) {
      //   const response = axios.post(
      //     `${REACT_APP_BACKEND_ROUTE_URL}send_email/`,
      //     emailData,
      //     {
      //       headers: {
      //         Authorization: `Bearer ${authToken}`,
      //       },
      //     }
      //   );

      //   console.log("Email sent successfully", response.data);
      // } else {
      //   toast.error("Email service not activated for this license");
      // }
      if (sessionStorage.getItem("isEmailEnabled") !== "true") {
        toast.error("Email service not activated for this license");
      } else if (
        !selectedInvoice?.patient_email ||
        typeof selectedInvoice.patient_email !== "string" ||
        selectedInvoice.patient_email.trim() === ""

      ) {
        toast.error("Email not sent as patient's email address is unavailable");
      } else {
        axios
          .post(`${REACT_APP_BACKEND_ROUTE_URL}send_email/`, emailData, {
            headers: {
              Authorization: `Bearer ${authToken}`,
            },
          })
          .then((response) => {
            console.log("Email sent successfully", response.data);
            toast.success("Email Sent Successfully");
          })
          .catch((error) => {
            console.error("Error sending email", error);
            toast.error("Error sending email. Please try again.");
          });
      }
    } catch (error) {
      console.error("Error sending email", error);
    }
  };

  // const generateAndDownloadPDF = async () => {
  //   console.log("inside gen pdf");
  //   const input = document.getElementById("invoice-template");
  //   html2canvas(input, { useCORS: true, allowTaint: true, scrollY: 0 }).then(
  //     (canvas) => {
  //       const image = { type: "jpeg", quality: 0.98 };

  //       var pdf = new jsPDF("p", "in", [8.5, 11]);
  //       pdf.addImage(
  //         canvas.toDataURL("image/jpeg", 1.0),
  //         "JPEG",
  //         0,
  //         0,
  //         8.5,
  //         11
  //       );

  //       setPdfDataUri(pdf.output("datauri"));
  //     }
  //   );
  // };

  const generateAndDownloadPDF = async () => {
    const input = document.getElementById("invoice-template");

    // Added scale to improve resolution and background to remove transparency issues
    html2canvas(input, {
      useCORS: true,
      allowTaint: true,
      scrollY: 0,
      backgroundColor: "#ffffff",
      scale: 2,
    }).then((canvas) => {
      const image = { type: "jpeg", quality: 0.98 };
      const margin = [0.5, 0.5];

      var imgWidth = 8.5;
      var pageHeight = 11;

      var innerPageWidth = imgWidth - margin[0] * 2;
      var innerPageHeight = pageHeight - margin[1] * 2;

      var pxFullHeight = canvas.height;
      var pxPageHeight = Math.floor(canvas.width * (pageHeight / imgWidth));
      var nPages = Math.ceil(pxFullHeight / pxPageHeight);

      var pageHeight = innerPageHeight;

      var pageCanvas = document.createElement("canvas");
      var pageCtx = pageCanvas.getContext("2d");
      pageCanvas.width = canvas.width;
      pageCanvas.height = pxPageHeight;

      var pdf = new jsPDF("p", "in", [8.5, 11]);

      for (var page = 0; page < nPages; page++) {
        if (page === nPages - 1 && pxFullHeight % pxPageHeight !== 0) {
          pageCanvas.height = pxFullHeight % pxPageHeight;
          pageHeight = (pageCanvas.height * innerPageWidth) / pageCanvas.width;
        }

        var w = pageCanvas.width;
        var h = pageCanvas.height;
        pageCtx.fillStyle = "white"; // Ensure a white background on each canvas page
        pageCtx.fillRect(0, 0, w, h);
        pageCtx.drawImage(canvas, 0, page * pxPageHeight, w, h, 0, 0, w, h);

        if (page > 0) pdf.addPage();
        var imgData = pageCanvas.toDataURL(
          "image/" + image.type,
          image.quality
        );
        pdf.addImage(
          imgData,
          image.type,
          margin[1],
          margin[0],
          innerPageWidth,
          pageHeight
        );
      }

      setPdfDataUri(pdf.output("datauri"));
      pdf.save(`Invoice.pdf`);
    });
  };

  useEffect(() => {
    const check = CheckToken();
    console.log(check);
    setAuthToken(sessionStorage.getItem("accessToken") ?? "");
  }, []); // Run only once on component mount

  const fetchInvoiceList = async ({
    page,
    limit,
    isMounted = true,
  } = {}) => {
    if (!authToken) return;

    const safePage = Number.isFinite(page) ? page : 1;
    const safeLimit = Number.isFinite(limit) ? limit : 10;

    const requestData = {
      hip_id: facilityName,
      // Tell backend to apply pagination + return pagination object
      is_pagination_required: true,
      page: safePage,
      limit: safeLimit,
    };

    setInvoiceLoading(true);
    try {
      const res = await axios.post(
        `${REACT_APP_BACKEND_ROUTE_URL}get_all_invoices/`,
        requestData,
        {
          headers: { Authorization: `Bearer ${authToken}` },
        }
      );

      if (!isMounted) return;

      const invoices = Array.isArray(res?.data?.invoices) ? res.data.invoices : [];
      const pg = res?.data?.pagination || {};

      setInvoicePagination({
        page: Number(pg.page) || safePage,
        limit: Number(pg.limit) || safeLimit,
        total_records: Number(pg.total_records) || 0,
        total_pages: Number(pg.total_pages) || 0,
        has_next: Boolean(pg.has_next),
        has_prev: Boolean(pg.has_prev),
        next_page: pg.next_page ?? null,
        prev_page: pg.prev_page ?? null,
      });

      // Backend already filters active + orders by latest invoice_date.
      const invoicesWithId = invoices.map((invoice) => ({
        ...invoice,
        id: invoice.invoice_id,
        total: parseFloat(invoice.total_amount).toFixed(2),
      }));

      setInvoiceList(invoicesWithId);
    } catch (error) {
      console.error("Error fetching invoice list:", error);
    } finally {
      if (isMounted) setInvoiceLoading(false);
    }
  };

  useEffect(() => {
    let isMounted = true;
    const backendPage = paginationModel.page + 1;
    const backendLimit = paginationModel.pageSize;
    fetchInvoiceList({ page: backendPage, limit: backendLimit, isMounted });
    return () => {
      isMounted = false;
    };
  }, [authToken, facilityName, paginationModel.page, paginationModel.pageSize]);

  const handleEdit = (id) => {
    // Find the selected invoice based on the id
    const selectedInvoice = invoiceList.find(
      (invoice) => invoice.invoice_id === id
    );

    // Log the selected invoice and the entire invoiceList to the console
    console.log("Selected Invoice:", selectedInvoice);
    console.log("Complete Invoice List:", invoiceList);

    const modifiedData = {
      ...selectedInvoice,
      // patient_id: selectedInvoice.customer, // Assuming customer_id is the patient_id
      // name: selectedInvoice.customer_name, // Assuming name is the patient name
      patient_id: selectedInvoice.patient_id, // Assuming customer_id is the patient_id
      name: selectedInvoice.patient_name, // Assuming name is the patient name
    };

    // Navigate to the edit page and pass the invoice data in the location state
    history.push({
      pathname: `/editInvoice/${id}`,
      state: { data: modifiedData },
    });
  };

  const handleView = (id) => {
    const selectedInvoice = invoiceList.find(
      (invoice) => invoice.invoice_id === id || invoice.id === id
    );

    if (selectedInvoice) {
      history.push({
        pathname: `/viewInvoice/${id}`,
        state: { data: selectedInvoice },
      });
    } else {
      console.error(`Invoice with id ${id} not found in invoiceList`);
    }
  };

  const handleDelete = async (id) => {
    const message = `Are you sure you want to delete this invoice?`;
    const isConfirmed = await showConfirmDialog(message);

    if (isConfirmed) {
      console.log(`Deleting invoice with id: ${id}`);

      // Make an HTTP POST request for deletion
      const headers = {
        Authorization: `Bearer ${authToken}`,
        "Content-Type": "application/json", // Specify the content type as JSON
      };

      const requestData = {
        invoice_id: id,
      };

      const requestConfig = {
        headers: headers,
      };

      axios
        .post(
          `${REACT_APP_BACKEND_ROUTE_URL}delete_invoice/`,
          JSON.stringify(requestData),
          requestConfig
        )
        .then(() => {
          console.log("Invoice deleted successfully!");
          fetchInvoiceList();
          // Implement additional logic after successful deletion if needed
        })
        .catch((error) => {
          console.error("Error deleting invoice:", error);
          // Implement error handling logic
        });
    } else {
      console.log("Deletion canceled");
    }
  };

  const handleConvertToEstimate = async (id) => {
    const message = `Are you sure you want to convert this invoice to an estimate?`;
    const isConfirmed = await showConfirmDialog(message);
    if (isConfirmed) {
      console.log(`Converting invoice with id ${id} to an estimate`);
      // Implement the logic to convert invoice to estimate
    } else {
      console.log("Conversion canceled");
    }
  };
  const handleDrawerOpen = () => {
    setDrawerOpen(true);
  };

  const handleDrawerClose = () => {
    setDrawerOpen(false);
  };
  const getRowClassName = (params) => {
    return "custom-row";
  };

  const brandingItem = brandingData?.find(
    (item) => item.name === "branding_statements"
  );
  const brandingContent = brandingItem?.content || null;

  // Extract the 'collateralBrandStatement' and 'themeColour' from JSON
  const collateralBrandStatement =
    brandingContent?.collateralBrandStatement || null;
  const themeColour = brandingContent?.themeColour || "#21cdc0";

  // Find the 'collateral_image.png' and get its base64 content directly
  const collateralImageItem = brandingData?.find(
    (item) => item.name === "collateral_image"
  );
  const collateralImage = collateralImageItem?.content || null;

  // Find the 'email_banner.png' and get its base64 content directly
  const emailBannerItem = brandingData?.find(
    (item) => item.name === "email_banner"
  );
  const emailBanner = emailBannerItem?.content || null;

  const generatePdf = () => {
    const doc = new jsPDF();

    // const tableColumns = [
    //   "ID",
    //   "Name",
    //   "Description",
    //   "Fee",
    //   "Added on",
    //   "Expiry date",
    //   "Status",
    // ];
    doc.autoTable({
      head: [["Invoice number", "Patient Name", "Invoice Date", "Gross Amount", "Discount (%)", "Paid amount", "Outstanding", "Payment", "Balance amount"]],
      body: invoiceList.map((invoice) => [
        invoice.invoice_number,
        displayPatientName(invoice.patient_name),
        invoice.invoice_date,
        invoice.total_amount,
        invoice.discount,
        formatInr(getInvoicePaidAmount(invoice)),
        formatInr(getInvoiceOutstanding(invoice)),
        invoice.partial_payment,
        invoice.balance_amount,
      ])
    });
    doc.save('Invoice_List.pdf');
  };

  const generateCsvData = () => {
    return invoiceList.map((invoice) => ({
      "Invoice number": invoice.invoice_number,
      "Patient Name": displayPatientName(invoice.patient_name),
      "Invoice Date": invoice.invoice_date,
      "Gross Amount": invoice.total_amount,
      "Discount (%)": invoice.discount,
      "Paid amount": formatInr(getInvoicePaidAmount(invoice)),
      "Outstanding": formatInr(getInvoiceOutstanding(invoice)),
      "Payment": invoice.partial_payment,
      "Balance amount": invoice.balance_amount,
    }));
  };


  return (
    <>
      {/* Open Staging Area Button */}
      <Tooltip title="Open Stageing Area">
        <Fab
          style={{
            color: "#fff",
            backgroundColor: "#0E3F66",
            overflow: "hidden",
            position: "fixed",
            bottom: 86,
            right: 16,
            marginRight: 1,
            borderRadius: "30px",
          }}
          color="primary"
          onClick={handleDrawerOpen}
        >
          <ArrowForwardIcon />
        </Fab>
      </Tooltip>

      <Drawer
        anchor="right"
        open={drawerOpen}
        onClose={handleDrawerClose}
        PaperProps={{
          sx: { width: "40%" },
        }}
      >
        <div style={{ padding: "20px" }}>
          <Button onClick={handleDrawerClose} style={{ marginBottom: "10px" }}>
            <ArrowBackIcon />
          </Button>
          {drawerOpen && <StagingArea pathname="/newInvoice" />}
        </div>
      </Drawer>

      <SideNavbar />
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: "1fr auto", // One column for text, one for button
          alignItems: "center",
          padding: "12px",
          gap: "20px", // Space between text and button
          marginBottom: "5px",
          // paddingX: { xs: 2, sm: 3 }, // Add padding for smaller screens
        }}
      >
        <p
          style={{
            fontSize: "32px",
            fontWeight: "bold",
            textAlign: "left",
            color: "#172935",
            margin: 0, // Remove default margin to align properly
          }}
        >
          Billing Invoices
        </p>

        <button
          onClick={handleAddItem}
          type="button"
          className="btn btn__secondary btn__rounded btn__block mt-2"
          // variant="contained"
          // color="primary"
          style={{
            backgroundColor: "#0E3F66",
            borderRadius: "8px",
            fontSize: "14px",
            paddingX: { xs: 2, sm: 3 },
            paddingY: 1,
            textTransform: "none",
            // "&:hover": {
            //   backgroundColor: "#0C3555",
            // },
          }}
        >
          + Add Invoice
        </button>

      </Box>
      <div className="display-flex">
        {invoiceList !== undefined && invoiceList.length > 0 ? (
          <DataGrid
            rows={invoiceList}
            columns={[
              {
                field: "invoice_number",
                headerName: "Invoice Number",
                width: 180,
              },
              {
                field: "patient_name",
                headerName: "Patient Name",
                width: 180,
                renderCell: (params) => (
                  <span>{displayPatientName(params.value)}</span>
                ),
              },
              { field: "invoice_date", headerName: "Invoice Date", width: 150 },
              { field: "due_date", headerName: "Due Date", width: 150 },
              { field: "total_amount", headerName: "Gross Amount", width: 120 },
              { field: "discount", headerName: "Discount (%)", width: 100 },
              {
                field: "paid_amount",
                headerName: "Paid Amount",
                width: 130,
                align: "right",
                headerAlign: "right",
                sortable: true,
                valueGetter: (value, row) => getInvoicePaidAmount(row),
                renderCell: (params) => (
                  <span>{formatInr(getInvoicePaidAmount(params.row))}</span>
                ),
              },
              {
                field: "outstanding",
                headerName: "Outstanding",
                width: 130,
                align: "right",
                headerAlign: "right",
                sortable: true,
                valueGetter: (value, row) => getInvoiceOutstanding(row),
                renderCell: (params) => (
                  <span>{formatInr(getInvoiceOutstanding(params.row))}</span>
                ),
              },
              {
                field: "payment_status",
                headerName: "Payment Status",
                width: 130,
                renderCell: (params) => {
                  const total = parseFloat(params.row.total_amount || 0);
                  const paid = getInvoicePaidAmount(params.row);

                  let displayStatus = "Pending";
                  let textColor = "#172935"; // default dark

                  if (paid >= total - 0.01 && total > 0) {
                      displayStatus = "Paid";
                      textColor = "#065f46"; // green
                  } else if (paid >= 1) {
                      displayStatus = "Partially Paid";
                      textColor = "#9a3412"; // orange
                  } else if (paid < 1) {
                      displayStatus = "Pending";
                      textColor = "#991b1b"; // red
                  }

                  return (
                    <span style={{ color: textColor, fontWeight: 500 }}>
                      {displayStatus}
                    </span>
                  );
                },
              },
              {
                field: "make_payment",
                headerName: "Make Payment",
                width: 150,
                sortable: false,
                renderCell: (params) => {
                  const total = parseFloat(params.row.total_amount || 0);
                  const paid = getInvoicePaidAmount(params.row);
                  const isFullyPaid = paid >= total - 0.01 && total > 0;
                  const canPay = !isFullyPaid;
                  
                  return canPay ? (
                    <Button
                      variant="contained"
                      size="small"
                      onClick={() => handlePayNow(params.row)}
                      style={{
                        backgroundColor: "#0E3F66",
                        color: "#fff",
                        textTransform: "none",
                        fontWeight: "bold",
                        borderRadius: "8px",
                      }}
                    >
                      Pay Now
                    </Button>
                  ) : null;
                },
              },
              {
                field: "actions",
                headerName: "Actions",
                headerAlign: "center",
                align: "center",
                width: 200,
                minWidth: 200,
                sortable: false,
                renderCell: (params) => {
                  const total = parseFloat(params.row.total_amount || 0);
                  const paid = getInvoicePaidAmount(params.row);

                  const isFullyPaid = paid >= total - 0.01 && total > 0;
                  const isPartiallyPaid = paid >= 1 && !isFullyPaid;
                  
                  const actionsEnabled = isFullyPaid || isPartiallyPaid;

                  const deleteEnabled = isFullyPaid && isBillingAdmin;
                  const viewEnabled = actionsEnabled;
                  const mailEnabled = actionsEnabled;
                  return (
                    <div style={{ display: "flex", gap: "8px", flexWrap: "nowrap", alignItems: "center", justifyContent: "center", width: "100%" }}>
                      {/* <Tooltip title={isBillingAdmin ? "Edit" : "Edit (billing admin only)"}>
                        <EditIcon
                          style={{
                            color: isBillingAdmin ? "#0D233F" : "#ccc",
                            fontSize: "18px",
                            cursor: isBillingAdmin ? "pointer" : "not-allowed",
                            display: "block",
                            margin: "auto",
                            opacity: isBillingAdmin ? 1 : 0.5,
                            pointerEvents: isBillingAdmin ? "auto" : "none",
                          }}
                          onClick={() => handleEdit(params.row.invoice_id)}
                        />
                      </Tooltip>
                      <Tooltip title={deleteEnabled ? "Delete" : isFullyPaid ? "Delete (billing admin only)" : "Available when invoice is paid"}>
                        <DeleteIcon
                          style={{
                            color: deleteEnabled ? "#0D233F" : "#ccc",
                            fontSize: "18px",
                            cursor: deleteEnabled ? "pointer" : "not-allowed",
                            display: "block",
                            margin: "auto",
                            opacity: deleteEnabled ? 1 : 0.5,
                            pointerEvents: deleteEnabled ? "auto" : "none",
                          }}
                          onClick={() => deleteEnabled && handleDelete(params.row.invoice_id)}
                        />
                      </Tooltip> */}
                      <Tooltip title={viewEnabled ? "View" : "Available when invoice is paid/partially paid"}>
                        <VisibilityIcon
                          style={{
                            color: viewEnabled ? "#0D233F" : "#ccc",
                            fontSize: "18px",
                            cursor: viewEnabled ? "pointer" : "not-allowed",
                            display: "block",
                            opacity: viewEnabled ? 1 : 0.5,
                            pointerEvents: viewEnabled ? "auto" : "none",
                          }}
                          onClick={() => viewEnabled && handleView(params.row.invoice_id)}
                        />
                      </Tooltip>
                      <Tooltip title={mailEnabled ? "Send Mail" : !isEmailEnabled ? "Email feature is disabled" : "Available when invoice is paid/partially paid"}>
                        <MailIcon
                          style={{
                            color: mailEnabled ? "#0D233F" : "#ccc",
                            fontSize: "18px",
                            cursor: mailEnabled ? "pointer" : "not-allowed",
                            display: "block",
                            opacity: mailEnabled ? 1 : 0.5,
                            pointerEvents: mailEnabled ? "auto" : "none",
                          }}
                          onClick={() => mailEnabled && handleSendMail(params.row.invoice_id)}
                        />
                      </Tooltip>
                    </div>
                  );
                },
              },
            ]}
            components={{
              Toolbar: () => (
                <Grid
                  container
                  spacing={2}
                  alignItems="center"
                  justifyContent="space-between"
                  sx={{
                    mb: 2,
                  }}
                >
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    md={8}
                    sx={{ display: "flex", gap: 1 }}
                  >
                    <GridToolbarColumnsButton />
                    <GridToolbarFilterButton />
                    <GridToolbarDensitySelector />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    md={4}
                    sx={{
                      display: "flex",
                      gap: 1,
                      justifyContent: { xs: "center", sm: "flex-end" },
                    }}
                  >
                    <Button
                      variant="text"
                      color="primary"
                      onClick={() => generatePdf()}
                      startIcon={<SaveAlt />}
                    >
                      Download PDF
                    </Button>
                    <CSVLink
                      data={generateCsvData()}
                      filename={"scan_share_records.csv"}
                      target="_blank"
                    >
                      <Button
                        variant="text"
                        color="primary"
                        startIcon={<SaveAlt />}
                      >
                        Download CSV
                      </Button>
                    </CSVLink>
                  </Grid>
                </Grid>
              ),
            }}
            paginationMode="server"
            rowCount={invoicePagination.total_records}
            paginationModel={paginationModel}
            onPaginationModelChange={(model) => setPaginationModel(model)}
            loading={invoiceLoading}
            initialState={{
              pagination: {
                paginationModel: { page: 0, pageSize: 10 },
              },
            }}
            pageSizeOptions={[10, 20, 50, 100]}
            getRowClassName={getRowClassName}
            sx={{
              "& .MuiDataGrid-root": {
                border: "1px solid #e0e0e0",
                borderRadius: "4px",
                fontFamily: "Arial, sans-serif",
              },
              "& .MuiDataGrid-columnHeaders": {
                backgroundColor: "#125386",
                color: "white",
                fontSize: "13px",
                fontWeight: "600",
                minHeight: "48px !important",
                "& .MuiDataGrid-columnHeaderTitle": {
                  color: "white",
                  fontWeight: "600",
                  fontSize: "13px",
                },
                "& .MuiDataGrid-columnHeader": {
                  borderRight: "1px solid rgba(255, 255, 255, 0.3)",
                  padding: "0 12px",
                },
                "& .MuiDataGrid-columnHeader:last-child": {
                  borderRight: "none",
                },
                "& .MuiDataGrid-iconButtonContainer": {
                  color: "white",
                },
                "& .MuiDataGrid-menuIcon": {
                  color: "white",
                },
                "& .MuiDataGrid-sortIcon": {
                  color: "white",
                },
                "& .MuiDataGrid-columnHeaderSortable": {
                  "& .MuiDataGrid-sortIcon": {
                    color: "white",
                  },
                },
                "& .MuiDataGrid-columnHeaderTitleContainer": {
                  "& .MuiDataGrid-sortIcon": {
                    color: "white",
                  },
                },
                "& .MuiSvgIcon-root": {
                  color: "white",
                },
              },
              "& .MuiDataGrid-row": {
                backgroundColor: "white",
                minHeight: "40px !important",
                "&:nth-of-type(even)": {
                  backgroundColor: "white",
                },
                "&:hover": {
                  backgroundColor: "#f8f9fa",
                },
                "&.Mui-selected": {
                  backgroundColor: "#e3f2fd",
                  "&:hover": {
                    backgroundColor: "#e3f2fd",
                  },
                },
                borderBottom: "1px solid #e0e0e0",
              },
              "& .MuiDataGrid-cell": {
                borderRight: "1px solid #e0e0e0",
                fontSize: "12px",
                color: "#374151",
                padding: "8px 12px",
                minHeight: "40px !important",
                "&:last-child": {
                  borderRight: "none",
                },
                "&:focus": {
                  outline: "none",
                },
              },
              "& .MuiDataGrid-cell[data-field='actions']": {
                overflow: "visible",
                "& .MuiDataGrid-cellContent": {
                  overflow: "visible",
                },
              },
              "& .MuiDataGrid-cellContent": {
                fontSize: "12px",
                color: "#374151",
                fontWeight: "400",
              },
              "& .MuiDataGrid-footerContainer": {
                backgroundColor: "#f8f9fa",
                borderTop: "1px solid #e0e0e0",
                minHeight: "52px",
              },
              "& .MuiTablePagination-root": {
                color: "#374151",
                fontSize: "12px",
              },
              "& .MuiDataGrid-toolbarContainer": {
                backgroundColor: "#f8f9fa",
                borderBottom: "1px solid #e0e0e0",
                padding: "8px 16px",
              },
            }}
          />
        ) : (
          <NoDataPage />
        )}
      </div>

      <div
        id="invoice-template"
        style={{ position: "absolute", left: "-9999px" }}
      >
        {selectedInvoice ? (
          <Card style={{ height: "auto" }}>
            <Grid
              container
              style={{ backgroundColor: themeColour, padding: "20px" }}
            >
              <Grid item xs={6}>
                <Typography
                  variant="h4"
                  style={{ color: "black", fontWeight: "bold" }}
                >
                  INVOICE
                </Typography>
              </Grid>
              <Grid item xs={6} textAlign="left">
                {collateralImage && (
                  <img
                    src={`data:image/png;base64,${collateralImage}`}
                    alt="Collateral"
                    width="100px"
                    height="60px"
                    style={{ paddingBottom: "3px", paddingTop: "5px" }}
                  />
                )}
              </Grid>
            </Grid>

            <Grid container style={{ padding: "20px", marginTop: "10px" }}>
              <Grid item xs={6}>
                <Typography variant="h6" style={{ fontWeight: "bold" }}>
                  Billed To
                </Typography>
                <Typography variant="subtitle1">
                  {displayPatientName(selectedInvoice.patient_name)}
                </Typography>
                <Typography variant="subtitle1">
                  {selectedInvoice.address}
                </Typography>
                <Typography variant="subtitle1">
                  {selectedInvoice.phone}
                </Typography>
              </Grid>
              <Grid item xs={6} style={{ textAlign: "right" }}>
                <Typography variant="h6" style={{ fontWeight: "bold" }}>
                  Invoice No: {selectedInvoice.invoice_number}
                </Typography>
                <Typography variant="subtitle1">
                  Date: {selectedInvoice.invoice_date}
                </Typography>
              </Grid>
            </Grid>

            <Grid item xs={12} style={{ padding: "20px" }}>
              <Grid
                container
                style={{
                  borderTop: "1px solid #ccc",
                  borderBottom: "1px solid #ccc",
                  padding: "10px",
                  fontWeight: "bold",
                }}
              >
                <Grid item xs={4}>
                  Item
                </Grid>
                <Grid item xs={2}>
                  Unit Cost (₹)
                </Grid>
                <Grid item xs={2}>
                  Qty
                </Grid>
                <Grid item xs={2}>
                  Amount (₹)
                </Grid>
              </Grid>

              {selectedInvoice.items.map((item, index) => (
                <Grid
                  container
                  key={index}
                  style={{
                    borderBottom: "1px solid #ccc",
                    padding: "10px 0",
                  }}
                >
                  <Grid item xs={4}>
                    {item.item_name}
                  </Grid>
                  <Grid item xs={2}>
                    ₹{item.item_price}
                  </Grid>
                  <Grid item xs={2}>
                    {item.quantity}
                  </Grid>
                  <Grid item xs={2}>
                    ₹{item.subtotal}
                  </Grid>
                </Grid>
              ))}
            </Grid>

            <Grid container style={{ padding: "20px" }}>
              <Grid item xs={12} style={{ textAlign: "right" }}>
                <Typography variant="subtitle1">
                  Subtotal: ₹{selectedInvoice.total_amount}
                </Typography>
                <Typography variant="subtitle1">
                  Discount(%): {selectedInvoice.discount}
                </Typography>
                <Typography variant="subtitle1">
                  Tax(%): {selectedInvoice.tax}
                </Typography>
                <Typography variant="h6" style={{ fontWeight: "bold" }}>
                  Total: ₹{selectedInvoice.total}
                </Typography>
                <Typography variant="subtitle1">
                  Payment: ₹{selectedInvoice.partial_payment}
                </Typography>
                <Typography variant="subtitle1">
                  Balance Amount: ₹
                  {(
                    selectedInvoice.total - selectedInvoice.partial_payment
                  ).toFixed(2)}
                </Typography>
              </Grid>
            </Grid>

            <Grid container style={{ padding: "20px" }}>
              <Typography variant="subtitle1" style={{ fontWeight: "bold" }}>
                Invoice Terms:
              </Typography>
              <Typography variant="subtitle1">
                Please pay your invoice before {selectedInvoice.due_date}.
              </Typography>
            </Grid>

            {/* <FooterPdfTemplateWithDept
              departments={departments}
              themeColour={themeColour}
            /> */}
            <Box sx={{ width: "100%", mt: 4 }}>
              <Box
                sx={{
                  bgcolor: themeColour || "#21cdc0",
                  color: "white",
                  p: 1,
                  textAlign: "center",
                }}
              >
                <Grid
                  container
                  justifyContent="center"
                  alignItems="center"
                  sx={{ textAlign: "center" }}
                >
                  <Grid item xs={12}>
                    <Typography variant="subtitle1" style={{ fontWeight: "bold" }}>
                      Enhanced Patient Care Powered by Hlthtek Digital Healthcare Platform
                      (visit: https://www.hlthtek.com )
                    </Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <img src={Navlogo} alt="hlthtek Logo" style={{ height: "30px" }} />
                  </Grid>
                </Grid>
              </Box>
            </Box>
          </Card>
        ) : (
          <h1>No invoice selected</h1>
        )}
      </div>
      <InvoicePayment
        open={openPaymentModal}
        onClose={() => setOpenPaymentModal(false)}
        invoice={invoiceForPayment}
        onStatusUpdated={() => {
          // Re-fetch invoices to update status in the list
          const pageToFetch = paginationModel.page + 1;
          setInvoiceLoading(true);
          setInvoiceList([]);
          axios
            .get(
              `${REACT_APP_BACKEND_ROUTE_URL}get_all_invoices/?page=${pageToFetch}&limit=${paginationModel.pageSize}`,
              {
                headers: {
                  Authorization: `Bearer ${sessionStorage.getItem("accessToken")}`,
                },
              }
            )
            .then((res) => {
              if (res.data.status === "Success") {
                setInvoiceList(res.data.data || []);
                setInvoicePagination(res.data.pagination || {});
              }
            })
            .catch((err) => {
              console.log(err);
            })
            .finally(() => {
              setInvoiceLoading(false);
            });
        }}
        onAfterClose={() => {
          setInvoiceForPayment(null);
        }}
      />
    </>
  );
};

export default Invoice;
